<template>
  <el-card class="box-card mt10">
    <div class="date-item">
      <el-link type="primary" :underline="false">达标标准</el-link>
      <div class="order-today">
        <el-link :type="orderToday === 2?'primary':''" :underline="false" @click="handleOrderToday(2)">按周</el-link>
        <el-link :type="orderToday === 3?'primary':''" :underline="false" @click="handleOrderToday(3)">按月</el-link>
      </div>
      <div class="today-data" v-if="yearData">
        <p>本年客户达标情况<br /><span>{{yearData.actualCustomerCount}}</span><em>（{{yearData.customerCountPercen}}%）</em></p>
        <p>本年收款达标情况<br /><span>{{yearData.actualReceivePayment}}</span><em>（{{yearData.receivePaymentPercen}}%）</em></p>
        <p>本年出货达标情况<br /><span>{{yearData.actualShipmentCount}}</span><em>（{{yearData.shipmentCountPercen}}%）</em></p>
      </div>
    </div>
    <echarts-vue :echart-data="echartData" echartName="echarts" />
  </el-card>
</template>

<script>
import echartsVue from './echarts.vue'
import homeStatisticsApi from '@/api/home'
import { getWeekDates, formatDate ,getMonthDates} from '@/utils/index'
export default {
  components: { echartsVue },
  data() {
    return {
      dateTime: [],
      orderToday: 2, //2 周 3 月
      echartsData: [],
      xData: [],
      yearData: null
    }
  },
  created() {
    this.startTime = getWeekDates()[0]
    this.endTime = getWeekDates()[1]
    this.getfindMoneyTotalByDate();
    this.getYearByDate()
  },
  methods: {
    getYearByDate() {
      let now = new Date();
      let start = new Date(now.getFullYear(), 0, 1);
      let end = new Date(now.getFullYear() + 1, 0, 0);
      let parmas = {
        startTime: formatDate(start) + ' 00:00:00',
        endTime: formatDate(end) + ' 23:59:59',
        timeType: 5
      }
      homeStatisticsApi.complianceStandardsK(parmas).then(({ data }) => {
        if (data.length > 0) {
          this.yearData = data[0]
        }
      })
    },
    getfindMoneyTotalByDate() {
      let now = new Date();
       let start = new Date(now.getFullYear(), 0, 1);
      let time = this.orderToday === 2 ? getWeekDates() : getMonthDates()
      let parmas = {
        startTime: formatDate(start) + ' 00:00:00',
        endTime: time[1] + ' 23:59:59',
        timeType: this.orderToday
      }
      homeStatisticsApi.complianceStandardsK(parmas).then(({ data }) => {
        if (data.length > 0) {
          this.calcDate(data)
          this.getEcharts(data)
        }
      })
    },
    calcDate(data) {
      let { orderToday } = this;
      let dateList = []
      if (orderToday === 2) {
        data.forEach((item, index) => {
          let date = item.startTime.substr(0, 10).replace(/\-/g, "/")
          dateList.push(`第${index + 1}周 ${date}`)
        });
      } else if (orderToday === 3) {
        data.forEach(item => {
          item.date = item.startTime.substr(0, 7).replace(/\-/g, "/")
        });
        dateList = data.map(item => item.date)
      }
      this.xData = dateList
    },
    handleOrderToday(type) {
      if (this.orderToday === type) return
      this.orderToday = type
      this.getfindMoneyTotalByDate();
    },
    getEcharts(echartsData) {
      this.echartsData = this.synthesisSeriesData(echartsData, [
        { name: "客户", color: "#02A4FF", key: "actualCustomerCount", percent: 'customerCountPercen' },
        { name: "收款", color: "#4DE1E9", key: "actualReceivePayment", percent: 'receivePaymentPercen' },
        { name: "出货", color: "#C11FFD", key: "actualShipmentCount", percent: 'shipmentCountPercen' },
      ], "line")
    },
    //合成图标Y轴信息
    synthesisSeriesData(datalist, ydata, chartType) {
      let param = {}, itemStyle = {};
      if (chartType === 'line') {
        param = { type: "line", smooth: true, symbol: 'none' };
      } else if (chartType === 'bar') {
        itemStyle = { borderRadius: [30, 30, 0, 0] }
        param = { type: "bar", barWidth: "10%", barCategoryGap: "30%" };
      }
      return ydata.map(item => {
        let dataArr = []
        datalist.forEach(itt => {
          dataArr.push({ value: itt[item.key], percent: itt[item.percent] })
        })
        return {
          name: item.name, ...param, data: dataArr,
          itemStyle: { ...itemStyle, color: item.color }
        }
      })
    }
  },
  computed: {
    echartData() {
      return {
        xAxisData: this.xData,
        yAxisData: this.echartsData
      };
    },
  }
}
</script>

<style lang="scss" scoped>
.date-item {
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .order-today {
    float: right;
  }
}
.order-cont {
  display: flex;
  // justify-content: space-between;
  margin: 20px 0;
  div {
    font-size: 16px;
    color: #000;
    width: 25%;
    display: inline-block;
    span {
      font-size: 48px;
    }
  }
}
.el-link {
  padding-left: 20px;
}
.today-data {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  p {
    font-size: 16px;
    margin: 8px 0 5px 36px;
    span {
      font-size: 30px;
      font-weight: bold;
    }
    em {
      color: #6c6c6c;
      font-style: normal;
    }
  }
}
</style>